import { render, staticRenderFns } from "./UserEvents.vue?vue&type=template&id=244ce693&scoped=true"
import script from "./UserEvents.vue?vue&type=script&lang=js"
export * from "./UserEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ce693",
  null
  
)

export default component.exports